
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/breakfast",
      function () {
        return require("private-next-pages/breakfast/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/breakfast"])
      });
    }
  